import React, { useState, useEffect } from 'react';

import { Avatar } from 'antd';

import styled from 'styled-components';

interface UserAvatarProps {
  url?: string;
  name?: string;
  size: number;
  scale: number;
}

const UserAvatarNew: React.FC<UserAvatarProps> = ({
  url,
  name,
  size,
  scale,
}) => {
  const [isShow, setIsShow] = useState(true);
  /** 处理名字 */
  const handleName = val => {
    let username = '';
    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
    if (reg.test(val)) {
      // name为汉字
      if (val.length > 2) {
        username = val.substr(-2, 2);
      } else {
        username = val;
      }
    } else {
      // name为英文
      const arr = val.toLowerCase().split(' ');
      const arr2 = arr.map(value => {
        return value.substr(0, 1);
      });
      username = arr2.join('');
    }
    return username;
  };
  const handleIsShow = () => {
    if (!url) {
      setIsShow(false);
    }
  };
  useEffect(() => {
    handleIsShow();
  }, [url]);
  return (
    <div style={{ display: 'inline-block', textIndent: '0px' }}>
      {isShow ? (
        <Avatar
          src={url}
          size={size}
          style={{ marginRight: '5px' }}
          icon="user"
          onError={() => {
            if (url === '') {
              setTimeout(() => {
                setIsShow(false);
              }, 500);
            } else {
              setIsShow(false);
            }
            return false;
          }}
        />
      ) : null}
      {!isShow && name ? (
        <AvatarBox size={size} scale={scale}>
          <span
            style={{
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}>
            {handleName(name)}
          </span>
        </AvatarBox>
      ) : null}
    </div>
  );
};

const AvatarBox = styled.div<{ size: number; scale: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: rgb(109, 144, 247);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border-radius: 50%;
  margin: 2px 0px 0 0;
  text-indent: 0px;
  cursor: pointer;
  span {
    /* line-height: 32px; */
    transform: ${props => `scale(${props.scale},${props.scale})`};
    /* text-indent: 0px; */
    letter-spacing: 0px;
    margin: 0 -2px;
  }
`;

export default UserAvatarNew;
